module.exports = __webpack_public_path__ + "static/media/mojave-day.220c7bf6.jpeg";